import moment from "moment";
import React from "react";

import Box from "veneer/Box";
import Divider from "veneer/Divider";
import Stack from "veneer/Stack";
import { Colors } from "veneer/Theme";
import Typography from "veneer/Typography";

import { WsConnStatus } from "cortex/ui/src/ui/ws-conn-status";

function Footer() {
  return (
    <Box bgcolor={Colors.white} flexShrink={0} mt="auto">
      <Divider />
      <Stack
        alignItems="center"
        direction="row"
        justifyContent="space-between"
        px={8}
        py={1}
      >
        <Typography>{moment().year()} &copy; Vistar Media, Inc.</Typography>
        <WsConnStatus />
      </Stack>
    </Box>
  );
}

export { Footer };
export default Footer;
